import {atom} from "recoil";
import {recoilPersist} from "recoil-persist";

const {persistAtom} = recoilPersist({
    key: "lessonPersist",
    storage:sessionStorage, //sessionStorage사용
})

export const gradeState = atom( {
    key: "gradeState",
    default: null
});

export const semesterState = atom( {
    key: "semesterState",
    default: null
});

export const hwGradeState = atom( {
    key: "hwGradeState",
    default: null
});

export const hwSemesterState = atom( {
    key: "hwSemesterState",
    default: null
});


export const lessonChapterListState = atom( {
    key: "lessonChapterListState",
    default: null
});

export const lessonListState = atom( {
    key: "lessonListState",
    default: null
});



export const lessonState = atom( {
    key: "lessonState",
    default: null
});


export const lessonHomeworkState = atom( {
    key: "lessonHomeworkState",
    default: null
});



export const lessonClassState = atom( {
    key: "lessonClassState",
    default: null,
    effects_UNSTABLE: [persistAtom],
});


export const lessonStageState = atom( {
    key: "lessonStageState",
    default: null,
    effects_UNSTABLE: [persistAtom],
});


export const lessonLessonInfoState = atom( {
    key: "lessonLessonInfoState",
    default: null,
    effects_UNSTABLE: [persistAtom],
});


export const dailyStageState = atom( {
    key: "dailyStageState",
    default: null,
    effects_UNSTABLE: [persistAtom],
});

export const dailyStageLevelState = atom( {
    key: "dailyStageLevelState",
    default: null,
    effects_UNSTABLE: [persistAtom],
});


export const lessonStageMenu = atom({
    key: "lessonStageMenu",
    default: null,
    effects_UNSTABLE: [persistAtom],
});